var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRightDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 28,
    viewBox: "0 0 14 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2701 14.0301C9.80381 13.5049 9.38538 13.047 8.97891 12.5756C6.1695 9.41062 3.34812 6.23219 0.538704 3.06722C-0.166639 2.2726 -0.154685 1.16823 0.538704 0.45443C1.07668 -0.0977566 1.87766 -0.151626 2.46345 0.319753C2.583 0.414029 2.6906 0.521771 2.78624 0.642983C6.33687 4.64297 9.87554 8.62948 13.4262 12.6295C14.1913 13.4914 14.1913 14.5015 13.4262 15.3635C9.85163 19.3769 6.301 23.3904 2.73842 27.4038C1.94939 28.2927 0.777801 28.1715 0.227872 27.1479C-0.106867 26.5284 -0.0710018 25.7742 0.323512 25.1951C0.407197 25.0739 0.490882 24.9796 0.586521 24.8718C3.71872 21.3432 6.83897 17.8146 9.97118 14.2995C10.0549 14.2052 10.1505 14.1379 10.2701 14.0301Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightDisabled);
export default __webpack_public_path__ + "static/media/chevron-right-disabled.a3d52b1c201d245c094ad6e94bceb525.svg";
export { ForwardRef as ReactComponent };